import { memo, useMemo } from 'react'
import styles from './PhoneFrame.module.css'

interface PhoneFrameProps {
  children: React.ReactNode
  statusBar?: {
    time?: string
    icons?: string
  }
  backgroundImage?: string
}

const PhoneFrame = memo(({ children, statusBar = {}, backgroundImage }: PhoneFrameProps) => {
  const { time = '9:41', icons = '📶 📡 🔋' } = statusBar

  const screenStyle = useMemo(() => {
    if (!backgroundImage) return undefined
    return {
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }
  }, [backgroundImage])

  return (
    <div className={styles.phone}>
      {/* Notch */}
      <div className={styles.notch}></div>

      {/* Status Bar */}
      <div className={styles.statusBar}>
        <div className={styles.time}>{time}</div>
        <div className={styles.icons}>{icons}</div>
      </div>

      {/* Screen Content */}
      <div
        className={styles.screen}
        style={screenStyle}
      >
        <div className={styles.screenImageOverlay}></div>
        {children}
      </div>

      {/* Home Button */}
      <div className={styles.homeButton}></div>
    </div>
  )
})

PhoneFrame.displayName = 'PhoneFrame'

export default PhoneFrame
